import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    data: Array
  }

  connect() {
    console.log("Invoice Status Chart Controller connected")
    
    // Check if Chart.js is loaded
    if (typeof Chart === 'undefined') {
      console.error("Chart.js is not loaded!")
      return
    }
    
    if (this.hasDataValue) {
      // Add a small delay to ensure DOM is ready
      setTimeout(() => this.initializeChart(), 300)
    } else {
      console.error("Missing chart data values")
    }
  }

  initializeChart() {
    const ctx = document.getElementById('invoiceStatusChart')
    if (!ctx) {
      console.error("Canvas element not found")
      return
    }
    
    const chartData = this.dataValue
    
    try {
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: chartData.map(item => item.name === 'open' ? 'Abiertas' : 'Cerradas'),
          datasets: [{
            data: chartData.map(item => item.count),
            backgroundColor: [
              'rgba(191, 23, 36, 0.7)',
              'rgba(69, 123, 157, 0.7)'
            ],
            borderColor: [
              'rgba(191, 23, 36, 1)',
              'rgba(69, 123, 157, 1)'
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom'
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.raw;
                  const total = context.dataset.data.reduce((acc, data) => acc + data, 0);
                  const percentage = Math.round((value / total) * 100);
                  return `${label}: ${value} (${percentage}%)`;
                }
              }
            }
          }
        }
      })
      console.log("Invoice Status Chart created successfully")
    } catch (error) {
      console.error("Error creating chart:", error)
    }
  }
}
